import { Shield, Award, Clock, Users } from 'lucide-react';

const badges = [
  {
    icon: Shield,
    title: 'Fully Licensed & Insured',
    description: 'All vehicles and drivers are certified',
  },
  {
    icon: Award,
    title: '15+ Years Excellence',
    description: 'Trusted by executives worldwide',
  },
  {
    icon: Clock,
    title: '24/7 Availability',
    description: 'Round-the-clock premium service',
  },
  {
    icon: Users,
    title: '10,000+ Happy Clients',
    description: '98% customer satisfaction rate',
  },
];

const TrustBadges = () => {
  return (
    <section className="py-12 bg-secondary">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {badges.map((badge, index) => {
            const Icon = badge.icon;
            return (
              <div
                key={index}
                className="flex flex-col items-center text-center group"
              >
                <div className="w-16 h-16 bg-primary/20 rounded-full flex items-center justify-center mb-4 group-hover:bg-primary/30 transition-colors">
                  <Icon className="w-8 h-8 text-primary" />
                </div>
                <h3 className="text-lg font-semibold text-white mb-2">
                  {badge.title}
                </h3>
                <p className="text-gray-300 text-sm">{badge.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;
